// Shared phone-input helpers for the customer-facing entry / look-up / signup
// screens. The twin of utils/emailValidation.js, and it exists for the same
// reason: these two functions were private to GetAccessCode.jsx, so the second
// screen that needed a phone field had no way to reuse them except to copy
// them. A copied validator is the failure this repo keeps re-learning -- one
// copy gets a fix and the others silently keep the bug.
//
//   formatPhone(input)
//     Live display formatting, "(NPA) NXX-XXXX". Strips non-digits and caps at
//     10 so a paste of "+1 (209) 555-0147 ext 3" cannot produce an 11-digit
//     field. The backend receives this formatted string; PhoneNumber.normalize
//     is what reduces it to digits server-side.
//
//   isValidPhoneFormat(phone)
//     Structural check only: exactly 10 digits after stripping. It does NOT
//     know whether the number is reachable, a landline, or unsubscribed --
//     those are carrier questions and they are answered server-side in
//     send_mms. Do not let this stand in for them.

// Live-format the phone input as the customer types: strip anything that
// isn't a digit, cap at 10, then re-emit in "(NPA) NXX-XXXX" form. Blocks
// letters entirely and keeps the visible field free of dashes / spaces
// the user would have to insert manually.
export function formatPhone(input) {
  const digits = (input || '').replace(/\D/g, '').slice(0, 10);
  if (digits.length === 0) return '';
  if (digits.length <= 3) return `(${digits}`;
  if (digits.length <= 6) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;

  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
}

export function isValidPhoneFormat(phone) {
  return (phone || '').replace(/\D/g, '').length === 10;
}
